
import React from 'react';
import { Controller } from 'react-hook-form';
import { TextField } from '@mui/material';
import { formatBRN} from '../utils/methods';

export const FormInputBRN = ({
  name = '',
  control,
  disabled,
  rules,
  label,
  setValue = () => {},
  staticValue,
  placeholder,
  sx,
  tabIndex,
}) => {
  return (
    <Controller
      name={name}
      control={control}
      rules={rules}
      render={({ field: { onChange, value }, fieldState: { error } }) => (
        <TextField
          helperText={error ? error.message : null}
          value={staticValue ? staticValue : value || ''}
          onChange={e => {
            const formattedValue = formatBRN(e.target.value);
            onChange(formattedValue); // react-hook-form onChange
            setValue(name, formattedValue); // 추가 setValue 호출 (필요한 경우)
          }}
          size="small"
          inputProps={{ maxLength: 14, tabIndex: tabIndex ?? 0 }}
          name={name}
          sx={sx}
          error={!!error}
          placeholder={placeholder}
          fullWidth
          disabled={disabled}
          label={label}
          variant="outlined"
        />
      )}
    />
  );
};